"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } /** When your routing table is too long, you can split it into small modules **/
var schoolRouter = {
  path: '/technocracyTest',
  component: _layout.default,
  redirect: '/technocracy',
  children: [{
    path: 'technocracy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/technocracy/index.vue'));
      });
    },
    // Parent router-view
    name: 'technocracy',
    meta: {
      title: '专家管理',
      icon: 'dashboard'
    }
  }, {
    path: 'technocracy-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/technocracy/technocracyAdd.vue'));
      });
    },
    // Parent router-view
    name: 'technocracy-add',
    meta: {
      title: '新增专家',
      icon: 'dashboard'
    }
  }, {
    path: 'technocracy-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/technocracy/technocracyEdit.vue'));
      });
    },
    // Parent router-view
    name: 'technocracy-edit',
    meta: {
      title: '编辑专家',
      icon: 'dashboard'
    }
  }, {
    path: 'technocracy-viewWorksList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/technocracy/viewWorksList.vue'));
      });
    },
    // Parent router-view
    name: 'technocracy-viewWorksList',
    meta: {
      title: '查看作品列表',
      icon: 'dashboard'
    }
  }, {
    path: 'technocracy-viewWorks',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/technocracy/viewWorks.vue'));
      });
    },
    // Parent router-view
    name: 'technocracy-viewWorks',
    meta: {
      title: '查看作品',
      icon: 'dashboard'
    }
  }]
};
var _default = exports.default = schoolRouter;